import { priceWatchApi } from "@apac/price-watch";

export const tenantFlightsReducers = {
  [priceWatchApi.reducerPath]: priceWatchApi.reducer,
};

export const tenantFlightsMiddleware = [priceWatchApi.middleware];
